import {getBrandPortalUrl, normalizeBrandName} from 'utils/brandUrls'
/**
 * Maps organization name or ID to the corresponding portal URL
 * Used for multi-portal profile switching
 */
export const getPortalUrlByOrganization = (organizationName: string | null | undefined): string => {
  const normalizedOrgName = normalizeBrandName(organizationName)

  return getBrandPortalUrl(normalizedOrgName, {preferLocalOrigin: true})
}

/**
 * Navigates to a different portal with profile and organization context
 * Preserves authentication state for seamless portal switching
 */
export const navigateToPortal = (organizationName: string) => {
  const portalUrl = getPortalUrlByOrganization(organizationName)
  return portalUrl
}
